import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, {
  Optional,
  Silent,
  Union,
} from "@/__main__/data-model.mjs";
import { model as activeSessionModel } from "@/feature-auth/models/active-session-model.mjs";
import { model as userPreferencesModel } from "@/feature-auth/models/user-preferences-model.mjs";

export const userModel = {
  id: String,
  email: String,

  name: String,
  birthday: Date,
  /** A `null` value on gender indicates they've opted out of selecting one. */
  gender: Union(["MALE", "FEMALE", null] as ["MALE", "FEMALE", null]),
  location: String,

  emailUpdatedAt: Date,
  insertedAt: Date,
  updatedAt: Date,

  isTrial: Boolean,
  roles: [{ id: String, code: String }],

  preferences: Silent(userPreferencesModel),

  summoners: [
    {
      id: String,
      isPro: Boolean,
      region: String,
      summonerId: String,
    },
  ],

  fortniteUsers: [
    {
      fortniteAccountId: String,
      id: String,
    },
  ],

  defaultSummoner: Silent({
    id: String,
    isPro: Boolean,
    region: String,
    summonerId: String,
  }),
  defaultFortniteUser: Silent({
    fortniteAccountId: String,
    id: String,
  }),
  defaultValorantUser: Silent({
    id: String,
    riotAccountId: String,
  }),

  riotSideGamesUsers: [
    {
      id: String,
      riotAccountId: String,
    },
  ],
  activeSessions: [activeSessionModel],
} satisfies ModelDefinition;

export const newUserModel = {
  id: userModel.id,
  email: userModel.email,

  name: Optional(userModel.name),
  birthday: Optional(userModel.birthday),
  gender: Optional(userModel.gender),
  location: Optional(userModel.location),
} satisfies ModelDefinition;

export type User = FromModel<typeof userModel>;
export type NewUser = FromModel<typeof newUserModel>;

const UserModel = createModel({
  data: userModel,
}).transform(userModel, (data) => data.data);

export default UserModel;
